import { CSSProperties, useEffect, useState } from "react";
import { Modal } from "../../../../../Modal/Default/Index";
import { ButtonOnlyTitle } from "../../../../../Buttons/ButtonOnlyTitle/Index";
import { useTaskCreation } from "../../../../../../hooks/useTaskCreation";
import { RoundedCloseButton } from "../../../../../Buttons/RoundedCloseButton/Index";
import axios from "../../../../../../services/axios";
import { useFilter } from "../../../../../../hooks/useFilter";
import { useTranslation } from "react-i18next";

const createEvaluatorModalStyle = {
  padding: "50px",
  width: "600px",
  height: "fit-content",
  borderRadius: 20,
  position: "relative"
} as CSSProperties;

export default function CancelateEvaluation() {
  const { t } = useTranslation();
  const { modalCancelateEvaluation, setModalCancelateEvaluation, taskId } = useTaskCreation();
  const { reloadTasks, setReloadTasks } = useFilter()

  return (
    <>
      <Modal
        visible={modalCancelateEvaluation}
        contentStyle={createEvaluatorModalStyle}
      >
        <div className="closeButton__startEvaluation">
          <RoundedCloseButton
            onClick={() => setModalCancelateEvaluation(false)}
          />
        </div>
        <section className="body__startEvaluation">
          <header>
            <h2 className="title__startEvaluation">{t("managementDialogs.cancelEvaluation")}</h2>
            <span className="description__startEvaluation">{t("managementDialogs.cancelEvaluationHelp")}</span>
          </header>
          <footer className="footerCreateEvaluator">
            <ButtonOnlyTitle
              title={t("commonUi.cancel")}
              theme="light"
              type="button"
              onClick={() => {
                setModalCancelateEvaluation(false)
                setReloadTasks(0)
              }}
            />
            <ButtonOnlyTitle
              title={t("taskRequests.confirm")}
              theme="info"
              type="button"
              onClick={() => {
                axios.put(`/tasks/cancel/${taskId}`).finally(() => {
                  setModalCancelateEvaluation(false)
                  setReloadTasks(taskId)
                })
              }}
            />
          </footer>
        </section>
      </Modal>
    </>
  )
}
